// extracted by mini-css-extract-plugin
export default {"description":"CorruptedFile_description__PFcp3"};